import React, { ReactNode } from 'react';

export const EmptyTemplate = ({ children }: { children: ReactNode[] | ReactNode }): JSX.Element => (
  <>{children}</>
);
